__turbopack_context__.v({
  "giftcarditem": "rnd_eq_giftcarditem",
  "giftcarditemimage": "rnd_eq_giftcarditemimage",
  "giftcarditemprice": "rnd_eq_giftcarditemprice",
  "giftcarditemtext": "rnd_eq_giftcarditemtext",
  "giftcards": "rnd_eq_giftcards",
});
